import { render, staticRenderFns } from "./Model12.vue?vue&type=template&id=2a0336fd&scoped=true&"
import script from "./Model12.vue?vue&type=script&lang=js&"
export * from "./Model12.vue?vue&type=script&lang=js&"
import style0 from "./Model12.vue?vue&type=style&index=0&id=2a0336fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0336fd",
  null
  
)

export default component.exports